export const NAME = "keywordGenerator";

export const DEFAULT_TAB = "DEFAULT_TAB";
export const KEYWORD_GROUPS_TAB = "KEYWORD_GROUPS_TAB";
export const GENERATED_KEYWORDS_TAB = "GENERATED_KEYWORDS_TAB";
